import React from "react";

export function LoadSpinner({ isModule = false }: { isModule?: boolean }) {
  const domain = window.location.host.includes("localhost") ? "localhost:44331" : window.location.host;
  return (
    <div
      id="loader-wrapper"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isModule ? "transparent" : "#FFF",
        width: "100%",
        height: isModule ? "100%" : "100vh",
      }}
    >
      <div
        id="loader"
        style={{
          width: "100px",
          height: "100px",
        }}
      >
        <img src={`https://${domain}/LoadSpinner.gif`} style={{ maxWidth: "100%", height: "auto", maxHeight: "100%" }} />
      </div>
    </div>
  );
}
